import {
    Grid, TextField, Button, MenuItem, CircularProgress
} from '@mui/material';
import { Form as FormikForm, useFormikContext } from 'formik';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CustomField } from '../../../inputs/CustomField';
import getDayjs from '../../../../context/DateInstance';
import { RESOURCE_TYPES } from './ResourcesFormValidator';

const CreateResourcesForm = ({ onClose }) => {
    const { values, setFieldValue, isSubmitting, errors, touched } = useFormikContext();

    const titleLength = (values.title || '').length;

    return (
        <FormikForm>
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <CustomField
                        name="title"
                        label="Nombre del documento"
                        fullWidth
                        as={TextField}
                        value={values.title || ''}
                        inputProps={{ maxLength: 120 }}
                        helperText={
                            touched.title && errors.title
                                ? errors.title
                                : `${titleLength}/120 caracteres`
                        }
                        error={touched.title && Boolean(errors.title)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <CustomField
                        name="type"
                        label="Tipo"
                        select
                        fullWidth
                        as={TextField}
                        value={values.type || ''}
                        error={touched.type && Boolean(errors.type)}
                        helperText={touched.type && errors.type}
                    >
                        {RESOURCE_TYPES.map((t) => (
                            <MenuItem key={t} value={t}>{t}</MenuItem>
                        ))}
                    </CustomField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha de publicación"
                            value={values.publication_date ? getDayjs(values.publication_date) : null}
                            onChange={(val) => setFieldValue('publication_date', val)}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: 'small',
                                    error: touched.publication_date && Boolean(errors.publication_date),
                                    helperText: touched.publication_date && errors.publication_date,
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                    <CustomField
                        name="url"
                        label="URL del documento"
                        fullWidth
                        as={TextField}
                        value={values.url || ''}
                        error={touched.url && Boolean(errors.url)}
                        helperText={touched.url && errors.url}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomField
                        name="description"
                        label="Descripción (opcional)"
                        fullWidth
                        multiline
                        rows={3}
                        as={TextField}
                        value={values.description || ''}
                    />
                </Grid>

                <Grid item xs={12} textAlign="right" mt={1}>
                    <Button variant="outlined" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button sx={{ ml: 2 }} variant="contained" type="submit" disabled={isSubmitting}>
                        {isSubmitting && <CircularProgress size="15px" sx={{ color: 'white', mr: 1 }} />}
                        {isSubmitting ? 'Guardando...' : 'Guardar'}
                    </Button>
                </Grid>

            </Grid>
        </FormikForm>
    );
};

export default CreateResourcesForm;
